export default {
  "validate-address_modal-title": "Verify your address details",
  "validate-address_title_suggested-matches": "Our Suggested Matches:",
  "validate-address_title_you-entered": "You Entered:",
  "validate-address_title_we-recommend": "We Recommend:",
  "___validate-address_text_loading-message": "",
  "validate-address_action_use-as-entered": "Use as entered",
  "validate-address_action_use-suggested-address": "Use suggested address",
  "___validate-address_action_edit-address": "",
  "validate-address_action_confirm-house-number": "Confirm Number",
  "validate-address_form-label_house-number": "Confirm Your House/Building Number",
  "___validate-address_form-error_house-number_required": "",

  // Errors
  "validate-address_error_default_header-title": "",
  "validate-address_error_default_header-text": "",
  "validate-address_error_multiple_header-title": "We found more than one match for your address.",
  "validate-address_error_multiple_header-text": "To proceed, please choose one of the options below.",
  "validate-address_error_streetpartial_header-title": "Sorry, we do not recognize your house or building number.",
  "validate-address_error_streetpartial_header-text": "To proceed, please check and choose from one of the options below.",
  "validate-address_error_interactionrequired_header-title": "We think that your address may be incorrect or incomplete.",
  "validate-address_error_interactionrequired_header-text": "To proceed, please choose one of the options below.",
  "validate-address_error_premisespartial_header-title": "We found more than one match for your address.",
  "validate-address_error_premisespartial_header-text": "To proceed, please choose one of the options below.",

};